import React, { useState } from 'react';
import { GridActions } from '@vyce/core/src/components/GridActions';
import { Box, MenuItem, MenuList, useTheme } from '@material-ui/core';
import { TbPencil } from 'react-icons/tb';
import { FiCopy } from 'react-icons/fi';
import { HiOutlineTrash } from 'react-icons/hi';
import { monochrome } from '../../../theme/styles';
interface Props {
  onDeleteButtonClick: Function;
  onEditButtonClick: Function;
  onDuplicateButtonClick: Function;
  disabled?: boolean;
}

export const TimesheetLineActions: React.FC<Props> = ({
  onDeleteButtonClick,
  onEditButtonClick,
  onDuplicateButtonClick,
  disabled = false,
}) => {
  const theme = useTheme();

  const [closeGridAction, setCloseGridAction] = useState<boolean>(false);

  const textColor = theme.palette.type === 'dark' ? monochrome.medium : monochrome.mediumdark;

  const resetCloseStatus = () => {
    setCloseGridAction(true);
    setTimeout(() => setCloseGridAction(false), 100);
  };

  return (
    <GridActions close={closeGridAction}>
      <MenuList>
        <MenuItem
          onClick={() => {
            resetCloseStatus();
            onEditButtonClick();
          }}
        >
          <Box display="flex" alignItems="center" gridGap={8} color={textColor}>
            <TbPencil size={14} /> Edit
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            resetCloseStatus();
            onDuplicateButtonClick();
          }}
        >
          <Box display="flex" alignItems="center" gridGap={8} color={textColor}>
            <FiCopy size={14} /> Duplicate
          </Box>
        </MenuItem>
        <MenuItem
          disabled={!!disabled}
          onClick={() => {
            resetCloseStatus();
            onDeleteButtonClick();
          }}
        >
          <Box display="flex" alignItems="center" gridGap={8} color={textColor}>
            <HiOutlineTrash size={14} /> Delete
          </Box>
        </MenuItem>
      </MenuList>
    </GridActions>
  );
};
